module.exports = __webpack_public_path__ + "24e9635760ad17f6f1d4d7123882dc2d.svg";